<script type="text/javascript">
	import ProductCard from "./ProductCard";
	import ImageSwiper from "../../../../components/widgets/gallery/ImageSwiper";
	import VueEasyLightbox from "vue-easy-lightbox";
	import { EventBus } from "../../../../public-app";
	import RelatedProducts from "./RelatedProducts";
	import RecentlyViewed from "./RecentlyViewed";
	import Login from "../../../../public-views/account/onpageLogin";
	import SocialShareBlock from "../../../../components/widgets/page-builder/widgets/web/SocialShareBlock";
	import ReviewForm from "../../../../components/widgets/forms/ReviewForm";
	import ReviewCarousel from "../../../../components/widgets/forms/ReviewCarousel";
	export default{
		data(){
			return {
				imagesLoading: true,
				listingsearch: '',
				action_error: [],
				loadingActionModal: true,
				favourites_status: false,
				share: false,
				quantity: 1,
				previewImgBtns: false,
				showLightbox: false,
				tryOnLoading: true,
				imgView: null,
				imgViewIndex: 0,
				hoverIndex: -1,
				hoverLink: -1,
				loadingVariants: false,
				lightboxImages: [],
				selectedvariantstotal: 0.00,
				selectedvariants: {},
				selectedcombination: null,
				recentlyviewedobject: {
					id: null,
					uid: null,
					name: null,
					cover_image: null,
					short_description: null,
					company: {
						nickname: null,
						logo: '',
					},
					url_rewrite: null,
					trade_price: null,
					tax_rule: null,
				},
				recentlyviewed: [],
				product: [],
				routearray: [],
				storageurl: '.s3.eu-west-2.amazonaws.com',
				form: {
					action: '',
					name: '',
					lastname: '',
					email: '',
					customer_uid: '',
					share_details: '',
					review: '',
					message: '',
					review_score: 0,
				},
				imgswiperOptions: {
		          slidesPerView: 5,
		          spaceBetween: 10,
		          pagination: {
		            el: '.swiper-pagination',
		            clickable: true
		          },
		          navigation: {
		            nextEl: '.swiper-button-next',
		            prevEl: '.swiper-button-prev'
		          }

		        },
		        swiperOptions: {
		          slidesPerView: 4,
		          spaceBetween: 30,
		          autoplay: {
				      delay: 2500,
				      disableOnInteraction: false
				    },
		          loop: false,
		          loopFillGroupWithBlank: false,
		          pagination: {
		            el: '.swiper-pagination',
		            clickable: true,
		          },
		          breakpoints: {
			          0: {
			            slidesPerView: 1,
			            spaceBetween: 20
			          },
			          // when window width is >= 320px
			          320: {
			            slidesPerView: 1,
			            spaceBetween: 20
			          },
			          // when window width is >= 480px
			          567: {
			            slidesPerView: 2,
			            spaceBetween: 30
			          },
			          // when window width is >= 640px
			          767: {
			            slidesPerView: 3,
			            spaceBetween: 40
			          },
			          990: {
			            slidesPerView: 4,
			            spaceBetween: 40
			          }
			        }
		          // Some Swiper option/callback...
		        },
		        reviewOptions: {
		          slidesPerView: 3,
		          spaceBetween: 30,
		          autoplay: {
				      delay: 2500,
				      disableOnInteraction: false
				    },
		          loop: false,
		          loopFillGroupWithBlank: false,
		          pagination: {
		            el: '.swiper-pagination',
		            clickable: true,
		          },
		          // Some Swiper option/callback...
		        },
		        reviewOptions1: {
		          slidesPerView: 1,
		          spaceBetween: 0,
		          autoplay: {
				      delay: 2500,
				      disableOnInteraction: false
				    },
		          loop: false,
		          loopFillGroupWithBlank: false,
		          pagination: {
		            el: '.swiper-pagination',
		            clickable: true,
		          },
		          // Some Swiper option/callback...
		        },
			}
		},
		props: {
			company: {
				type: Object
			},
			resource: {
				type: String,
				default: () => 'product'
			},
			product: {
				type: Object
			},
			user: {
				type: Object
			},
			exchange_rates: {
				type: Object,
				default: [],
			},
			selected_currency: {
				type: String,
				default: '',
			}
		},
		components: {
			SocialShareBlock,
			ProductCard,
			ImageSwiper,
			VueEasyLightbox,
			Login,
			RelatedProducts,
			RecentlyViewed,
			ReviewForm,
			ReviewCarousel
		},
		created(){
			window.scrollTo(0,0);
		
			//this.getResource(this.resource);
			let self = this;
				    setTimeout(function() {
				    	self.imagesLoading = false;
				    }, 800);
		},
		mounted(){
				
				this.isZeroRated(this.product);
				this.tryOnLoading = true;
				if(this.product.tryon !== null){
					if(this.product.tryon.url !== ''){
						this.getTryOnScript(this.product.tryon.service);
					}
				}
				
				
		},
		methods: {
			getTryOnScript(service){
				if(service == 'PicUp Media'){
				
				   const script = document.createElement('script');
				    script.src = 'https://static.cloud.picupmedia.com/static/embed-btn-script.js';
				    script.async = true;
				    script.defer = true;
				    this.$refs.picupelement.appendChild(script);
				    let self = this;
				    setTimeout(function() {
				    	self.tryOnLoading = false;
				    }, 500);
				    
			
				}
			},
			existsInFavourites(id){
				var findIndex = this.user.wishlist.findIndex(item => item == id);
				if(findIndex > -1){
					this.favourites_status = true;
				}else{
					this.favourites_status = false;
				}
			},
			addToFavourites(id){
				this.loadingActionModal = true;
				axios.post('/customer-api/user/wishlist/add-remove', {product_id: id}, {headers: {'Authorization' : 'Bearer '+ this.user.api_token}}).then(response => {
					if(response.data[0] == 'add'){
						this.favourites_status = true;
						this.user.wishlist = response.data[1];
					
						//this.user.wishlist.push(id);

						
					}else if(response.data[0] == 'delete'){
						this.favourites_status = false;
						this.user.wishlist = response.data[1];
					}
					var self = this;
                setTimeout(function(){
	                self.loadingActionModal = false;                
                }, 300);
				}).catch(error => {
					this.action_error = error.data;
				});
			},
			isZeroRated(product){
				var tax_rule = product.tax_rule;
				console.log('zero: '+product);

					if(tax_rule !== null && tax_rule.country_rules.length > 0){
		    		var selected_rule = null;
		    		var selected_ruleIndex = -1;
			    	for(var ti = 0; ti < tax_rule.country_rules.length; ti++){
			    		selected_ruleIndex = tax_rule.country_rules[ti].countries.findIndex(item => item == country_id);
			    		if(selected_ruleIndex !== -1){
			    			selected_rule = tax_rule.country_rules[ti];
			    			ti = tax_rule.country_rules.length;
			    		}
			    	}
			    		  if(selected_rule !== null && selected_rule.value > 0){
		        			this.product["VAT_zero_rated"] = 0;
		         		}else{
		         			this.product["VAT_zero_rated"] = 1;
		         		}
		    	}else if(tax_rule !== null && tax_rule.country_rules.length == 0){
		    		if(tax_rule.percentage > 0){
		    			this.product["VAT_zero_rated"] = 1;
		    		}else{
		    			this.product["VAT_zero_rated"] = 0;
		    		}
		    		
		    	}else if(tax_rule == null){
		    		this.product["VAT_zero_rated"] = 0;
		    	}
			},
			hasReviewed(user_id){
				return this.product.reviews.findIndex(item => item.customer_id == user_id);
				
			},
			submitReview(uid){
				axios.post('/customer-api/product/'+uid+'/submit-review', this.form, {headers: {'Authorization' : 'Bearer '+this.user.api_token}}).then(response => {
					this.product.reviews.push(response.data);
					let self = this;
					setTimeout(function(){
						self.success_message = true;
						self.success_message_text = 'Your review has been submitted';
						self.loadReviews = false;
					}, 500);
				}).catch({

				});
			},
			isKeyValueActive(key, value){
				if(this.selectedvariants[key] == value){
					return true;
				}else{
					return false;
				}
			},
			addToCart(product, quantity, variant, combination){
		    	EventBus.$emit('add-to-cart', product, quantity, variant, combination);
		    },
			/**getResource(resource){
				this.routearray = this.$route.path.substring(1).split('/');
				axios.get('/website-api/widget/'+resource+'/'+this.routearray[this.routearray.length-1]).then(response => {
					this.product = response.data;
					
				}).catch(error => {
					this.product = [];
					console.log(error);
				});
			},**/
			imageSelected(img){
		    	if(this.imgView == null){
		    		this.product.images.unshift(this.product.cover_image);
		    	}
		    	this.imgView = JSON.parse(JSON.stringify(img));
		    },
		    calculateVariantsTotal(){
        		var total = 0.00;
        		for(let key in this.selectedvariants){
        			console.log(key);
        			total += parseFloat(this.selectedvariants[key].price_difference);
        		}
        		this.selectedvariantstotal = this.addTax(this.product, total);
        	},

        	addTax(product, price){
        		var tax_rule = product.tax_rule;
        		console.log(tax_rule);
		    	if((this.user !== null && this.user !== '') && (this.user.default_delivery_address !== '' && this.user.default_delivery_address !== null)){
		    		var country_id = this.user.default_delivery_address.country_id;
		    	}else{
		    		var country_id = product.company.country_id;
		    	}
		    	if(tax_rule !== null && tax_rule.country_rules.length > 0){
		    		var selected_rule = null;
		    		var selected_ruleIndex = -1;
			    	for(var ti = 0; ti < tax_rule.country_rules.length; ti++){
			    		selected_ruleIndex = tax_rule.country_rules[ti].countries.findIndex(item => item == country_id);
			    		if(selected_ruleIndex !== -1){
			    			selected_rule = tax_rule.country_rules[ti];
			    			ti = tax_rule.country_rules.length;
			    		}
			    	}
			    	console.log(selected_rule);
			    	if(tax_rule.type == 1){
		        		if(selected_rule !== null){
		        			var percentage = (parseFloat(selected_rule.value) / 100) + 1;
		        			return price * percentage;
		         		}else{
		         			return price * 1.2;
		         		}
	         		}else{
	         			if(selected_rule !== null){
		        			return price + selected_rule.value;
		         		}else{
		         			return price * 1.2;
		         		}
	         		}
         		}else if(tax_rule !== null && tax_rule.country_rules.length > 0){
         			var percentage = (parseFloat(tax_rule.percentage) / 100) + 1;
		        	return price * percentage;
         		}else {
		        	return price * 1.2;
         		}
        	},
        	/*addTax(price){
        		if(this.product.tax_rule !== null){
        			var percentage = (parseFloat(this.product.tax_rule.percentage) / 100) + 1;
        			return price * percentage;
         		}else{
         			return price;
         		}
        	},*/
		    setUpLightbox(){
		    	//this.product.images = JSON.parse(JSON.stringify(this.product.images).replaceAll('caption', 'title'));
		    		this.lightboxImages = [];
		    		var image = {};
		    		image["src"] = 'https://'+this.product.company.nickname+this.storageurl+''+this.product.cover_image.src.replaceAll('//', '/')+'?s='+this.product.company.nickname;
		    		image["title"] = this.product.cover_image.caption;
		    		this.lightboxImages.push(image);
		    	for(var i = 0; i < this.product.images.length; i++){
		    		var image = {};
		    		image["src"] = 'https://'+this.product.company.nickname+this.storageurl+''+this.product.images[i].src.replaceAll('//', '/')+'?s='+this.product.company.nickname;
		    		image["title"] = this.product.images[i].caption;
		    		console.log(image);
		    		this.lightboxImages.push(image);
		    		if(this.imgView == this.product.images[i]){
		    			this.imgViewIndex = (this.lightboxImages.length - 1);
		    		}
		    	}
		    	

		    },
		},
		  watch: {
        $route() {

        	this.$nextTick(() => {
        		 //this.loadingPage = true;
        		this.selectedvariantstotal = 0.00;
				this.selectedvariants = {};
				this.selectedcombination = null;
        		this.imagesLoading = true;
        		this.imgView = null;
        		this.imgViewIndex = 0;
        		window.scrollTo(0,0);
        		this.tryOnLoading = true;
        		if(this.product.tryon !== null){
					if(this.product.tryon.url !== ''){
						this.getTryOnScript(this.product.tryon.service);
					}
				}
				this.imagesLoading = false;
        		//this.loadTryOnScript;
        		 //this.getResource(this.resource);


        		 this.existsInFavourites(this.resource.id);
        		 
					
        		});
        	}
        },
        computed: {
        	/*loadTryOnScript(){
        		 if(this.product.tryon !== null){
					if(this.product.tryon.url !== ''){
						this.getTryOnScript(this.product.tryon.service);
					}
				}
        	},*/
        	recentlyViewed(){
        		if(this.product !== ''){
							this.recentlyviewedobject.id = this.product.id;
							this.recentlyviewedobject.uid = this.product.uid;
							this.recentlyviewedobject.name = this.product.name;
							this.recentlyviewedobject.cover_image = this.product.cover_image;
							this.recentlyviewedobject.short_description = this.product.short_description;
							this.recentlyviewedobject.company["nickname"] = this.product.company.nickname;
							this.recentlyviewedobject.company["logo"] = this.product.company.logo;
							this.recentlyviewedobject.url_rewrite = this.product.url_rewrite;
							this.recentlyviewedobject.trade_price = this.product.trade_price;
							this.recentlyviewedobject.tax_rule = this.product.tax_rule;
						}
						var viewed = window.sessionStorage.getItem("public_rv");
						
						if(!viewed){
							console.log('no viewed');
							//var vieweditems = JSON.parse(viewed);
							if(this.product !== ''){
								this.recentlyviewed.push(this.recentlyviewedobject);
							}
							window.sessionStorage.setItem("public_rv", JSON.stringify(this.recentlyviewed));
						}else{
							var vieweditems = JSON.parse(viewed);
								if(this.product !== ''){
										if(vieweditems.findIndex(item => item.id == this.product.id) == -1){
											vieweditems.push(this.recentlyviewedobject);
										}
								window.sessionStorage.setItem("public_rv", JSON.stringify(vieweditems));
								return vieweditems.reverse();
							}
							
						}
        	},
        	recentlyViewedFiltered(){
        		return this.recentlyViewed.filter(item => item.id !== this.product.id);
        	},
        	variantsTotal(){
        		var total = 0.00;
        		for(let key in this.selectedvariants){
        			console.log(key);
        			total =+ parseFloat(this.selectedvariants[key].price_difference);
        		}
        		return total;
        	},
        	priceIncVat(){
        		if(this.product.tax_rule !== null){
        			//var percentage = (parseFloat(this.product.tax_rule.percentage) / 100) + 1;
        			return this.addTax(this.product, this.product.sales_price);
         		}else{
         			return this.product.sales_price;
         		}
        	},
        	combinationPrice(){
        		if(this.selectedcombination !== null){
        		return parseFloat(this.addTax(this.product, this.selectedcombination.price_difference));
        		}else{
        			return parseFloat(0.00);
        		}
        	}
        }
	}

</script>
<template>
	<b-container fluid class="py-4 my-4 default-content">
		<vue-easy-lightbox
                :visible="showLightbox"
                :imgs="lightboxImages"
                :index="imgViewIndex"
                @hide="showLightbox = !showLightbox"
              ></vue-easy-lightbox>
		<b-row class="mb-4 px-4 px-xl-0">
			<b-col md="6" class="px-3 overflow-hidden mb-3">
				<b-overlay :show="imagesLoading">
				<a v-if="imagesLoading == false" class="position-relative d-block" @mouseenter="previewImgBtns = true" @mouseleave="previewImgBtns = false" @click="setUpLightbox(), showLightbox = !showLightbox">
				<b-img-lazy v-if="(product.cover_image !== null) && (imgView == null)" :src="'https://'+product.company.nickname + storageurl + product.cover_image.src.replaceAll('//', '/')+'?s='+product.company.nickname+''" class="img-fluid w-100 border mb-3" ></b-img-lazy>
				<b-img-lazy v-else-if="imgView !== null" :src="'https://'+product.company.nickname + storageurl + imgView.src.replaceAll('//', '/')" class="img-fluid w-100 border mb-3"> </b-img-lazy>
				<b-img-lazy v-else src="/images/product-placeholder.png" class="img-fluid w-100 border mb-3"></b-img-lazy>
				<transition name="fade-right">
				   <div class="position-absolute top-0 right-0 mt-3 mr-3 rounded" v-if="previewImgBtns == true">
	                          	<a class="btn btn-primary rounded-circle bg-peach-soft" href="javascript:;">
	                          		<i class="bx bx-search"></i>
	                          	</a>
	                </div>
	            </transition>
				</a>
				<ImageSwiper v-if="imagesLoading == false"  :swiperOptions="imgswiperOptions" :items="product.images" @image-selected="imageSelected" :imgClass="'border'" :isPublic="true" :s="product.company.nickname" :company="product.company" ></ImageSwiper>
				</b-overlay>
			</b-col>
			<b-col md="6" class="px-3 d-flex flex-column">
				<SocialShareBlock />
				
				<p class="mb-2 text-muted font-size-14">REFERENCE: {{product.reference}}</p>
				<h1 class="text-capitalize mb-2">{{product.name}}</h1>
				<div class="d-flex mb-2">
					<b-form-rating id="rating-inline" variant="warning" v-b-modal.modal-1 @click="form.action = 'review'"  inline no-border size="lg" class="bg-transparent" :readonly="true" v-model="product.reviews_avg_rating"></b-form-rating><span class="my-auto ml-2" v-if="product.reviews.length > 0"><small >{{parseFloat(product.reviews_avg_rating).toFixed(2)}} / 5 from {{product.reviews.length}} reviews</small></span>
					<a class="my-auto"  href="javascript:;" v-b-modal.modal-1  @click="form.action = 'review'">
						<i class="bx bx-pencil-alt"></i>
						<small>Write Review</small>
					</a>
					<div class="ml-auto" id="tryon-service" v-if="product.tryon !== null && product.tryon !== ''">
				<div v-if="'service' in product.tryon && product.tryon.service !== '' && product.tryon.service == 'PicUp Media'" class="btn btn-primary tryon-btn btn-rounded btn-md" ref="picupelement" data-source="picupmedia_gemlightbox" data-env="production" data-type="blink" data-image-type="ar-type-0" data-button-size="200" data-modal-width="1200" data-modal-height="800" :data-href="product.tryon.url"> <b-spinner v-if="tryOnLoading" small variant="white"></b-spinner> </div>
				
			</div>
				<a class="btn btn-light btn-rounded font-size-20 my-auto" :class="product.tryon !== null && product.tryon !== '' ? 'ml-2' : 'ml-auto'">
						<i class="mdi mdi-heart-outline text-danger" v-b-modal.modal-1 @click="form.action = 'favourites',addToFavourites(product.id)"></i>
					</a>
				</div>
				<p class="mb-3" v-html="product.short_description"></p>
				<!--<h4 class="font-size-28 mb-4" v-if="product.combinations.length == 0"><span class="currency">{{$attrs.selected_currency_symbol}}</span>{{(parseFloat(priceIncVat) + parseFloat(selectedvariantstotal)).toFixed(2)}}</h4>
				<h4 v-else class="font-size-28 mb-4"><span class="currency">{{$attrs.selected_currency_symbol}}</span>{{(parseFloat(priceIncVat) + parseFloat(combinationPrice)).toFixed(2)}}</h4>
				-->
				<h4 v-if="product.combinations.length == 0" class="font-size-28 mb-4"><span class="currency">{{$attrs.selected_currency_symbol}}</span>{{((parseFloat(priceIncVat) + parseFloat(selectedvariantstotal)) * (1 / exchange_rates[product.company.trading_currency_code])).toFixed(2)}}
					</h4>
					<h4 v-else class="font-size-28 mb-4"><span class="currency">{{$attrs.selected_currency_symbol}}</span>{{((parseFloat(priceIncVat) + parseFloat(combinationPrice))  * (1 / exchange_rates[product.company.trading_currency_code])).toFixed(2) }}</h4>
				<!--<h4 class="font-size-28 mb-4" v-if="product.combinations.length == 0"><span class="currency">{{$attrs.selected_currency_symbol}}</span>{{(product.company.trading_currency_code == selected_currency ? (addTax(product.tax_rule, product.price_exc) + parseFloat(selectedvariantstotal)).toFixed(2) : (addTax(product.tax_rule, product.price_exc) + parseFloat(selectedvariantstotal)).toFixed(2) * (1 / exchange_rates[selected_currency]))}}</h4>
				<h4 v-else class="font-size-28 mb-4"><span class="currency">{{$attrs.selected_currency_symbol}}</span>{{product.company.trading_currency_code == selected_currency ? (addTax(product.tax_rule, product.price_exc) + parseFloat(combinationPrice)).toFixed(2) : ((addTax(product.tax_rule, product.price_exc) + parseFloat(combinationPrice)).toFixed(2)) * (1 / exchange_rates[selected_currency])}}</h4>-->
				<!--<h5 class="text-uppercase font-size-12 text-underline spaced-title mt-2 pt-3">Product Features</h5>
				<b-row>
				     <div class="col-md-12" v-if="product.attributes.length == 0">
                    <b-card class="shadow-none text-center border mb-2 py-4">
                      <i class="bx bxs-cube font-size-24 text-muted"></i>
                      <h4>No Active Features</h4>
                  </b-card>
                  </div>
                 <div class="col-md-12 mb-2" v-if="product.attributes.length !== 0">
                <div class="row">
               <div class="col-md-12">
                <div class="form-control-group">
                <b-list-group class="list-group" flush>
                <li v-for="(active_attributes, index) in product.attributes" class="list-group-item p-0 d-flex py-3">
                <span class="my-auto pl-4 w-25">
                  <img v-if="active_attributes.attribute.image" :src="active_attributes.attribute.image" class="avatar-xs rounded-circle mr-2">
                  <img v-else src="/images/product-placeholder.png" class="avatar-xs rounded-circle mr-2">
                {{active_attributes.attribute.name}}
              </span>
              <span class="w-25">
                <img v-if="active_attributes.value.image" :src="active_attributes.value.image" class="avatar-xs rounded-circle mr-3">
                <img v-else src="/images/product-placeholder.png" class="avatar-xs rounded-circle ml-2 mr-2"> {{active_attributes.value.name}}
              </span>
              <span class="my-auto pl-4 w-50 d-flex">
              	<span class="ml-auto">{{active_attributes.measurement_value}}{{active_attributes.units.suffix}}
              	</span>
              </span>
              
			          </li>
			        </b-list-group>
			      </div>
			    </div>
			  </div>
			</div> 
			</b-row>-->
			

			<div class="border-top pt-3" v-if="product.combinations.length == 0" >
					<h5 class="text-uppercase font-size-12 text-underline spaced-title mb-4" v-if="product.grouped_variants.length > 0">Select Customisation Options</h5>
				<div class="w-100" v-for="(variants, key) in product.grouped_variants">
					
					<div class="d-flex mb-2">
					<!--<img :src="storageurl +'/'+ variants[0].attribute.image + '?s='+product.company.nickname" class="avatar-xs">-->
					<h5 class="text-uppercase font-size-12 spaced-title ml-2 my-auto">{{variants[0].attribute.name}}</h5>
					</div>
					<b-row >
						<b-col md="6" v-for="value in variants">
						<b-overlay :show="loadingVariants">
							<a href="javascript:;" @click="selectedvariants[key] = value, calculateVariantsTotal(), loadingVariants = true, loadingVariants = false" >
							<b-card class="border-radius-1em border shadow-none text-dark mb-3" body-class="d-flex" :class="{'border-primary' : selectedvariants[key] == value}">
								<span class="my-auto" v-if="value.value !== null"><img v-if="value.value.image !== null" :src="'https://'+product.company.nickname + storageurl +'/'+ value.value.image + '?s='+product.company.nickname" class="avatar-sm rounded-circle mr-2 border"> 
								</span>
								<span class="my-auto mr-2" v-if="value.value !== null">{{value.value.name}}</span> <span class="my-auto">{{value.measurement_value}}</span><span class="my-auto mr-2" v-if="value.units !== null">{{value.units.suffix}}</span>
								<span class="badge badge-light bg-light my-auto ml-auto font-size-14">
								<span class="ml-auto my-auto" v-if="value.price_difference > 0">+</span><span class="ml-auto my-auto" v-else>-</span><span class="currency">{{$attrs.selected_currency_symbol}}</span>{{(addTax(product, value.price_difference) * (1 / exchange_rates[product.company.trading_currency_code])).toFixed(2)}}
								</span>
							</b-card>
							</a>
						</b-overlay>
						</b-col>
					</b-row>
				</div>
			</div>
				<div v-else >
					<h5 class="text-uppercase font-size-12 text-underline spaced-title mt-2 pt-3">Select Customisation Options</h5>
				<div class="w-100" v-for="(combination, index) in product.combinations">
					<a href="javascript:;" @click="selectedcombination = combination" >
						<b-card class="border-radius-1em border shadow-none text-dark" :class="{'border-primary' : selectedcombination == combination}">
					<b-row>
						<b-col md="3" v-for="value in combination.variants">
							
							
								<span v-if="value.variant.attribute !== null">{{value.variant.attribute.name}}</span> 
								<span v-if="value.variant.value !== null">{{value.variant.value.name}}</span> {{value.variant.measurement_value}}<span v-if="value.variant.units !== null">{{value.variant.units.suffix}}</span>
								
								
							
							
						</b-col>
						<b-col md="12" class="d-flex">
							<span class="badge badge-light bg-light ml-auto mt-2 font-size-14">
							<span v-if="combination.price_difference > 0">+</span><span v-else>-</span><span class="currency">{{$attrs.selected_currency_symbol}}</span>{{(addTax(product, combination.price_difference) * (1 / exchange_rates[product.company.trading_currency_code])).toFixed(2)}}
								</span>
						</b-col>
					</b-row>
					</b-card>
					</a>
				</div>
				</div>


				<div class="d-flex mb-2">
					 <b-button variant="-light" :disabled="quantity < 2" id="tooltip-add" @click="quantity--" class="btn btn-light font-size-16 btn-rounded w-25 mr-1 my-auto"><i class="mdi mdi-minus"></i></b-button>
					  <b-form-group label="" class="w-50 my-auto mx-1">
						<b-form-input type="number" v-model="quantity" size="lg" /></b-form-group>
					  <b-button variant="-light" :disabled="quantity >= product.total_qty " @click="quantity++" class="btn btn-light font-size-16 btn-rounded w-25 my-auto m1-1"><i class="mdi mdi-plus"></i></b-button>
				</div>
				<div class="d-flex">
				
					<b-button variant="primary" class="btn-rounded btn-block w-100 text-white btn-lg":disabled="((product.combinations.length > 0) && (selectedcombination == null)) || (((product.variants.length > 0) && (product.combinations.length == 0)) && (Object.keys(selectedvariants).length === 0))" @click="addToCart(product, quantity, selectedvariants, selectedcombination)">
					Add to Cart
					</b-button>	
					
					<!--<a class="btn btn-primary my-auto btn-rounded w-75"  >Add to Cart</a>-->
				</div>
				<div class="d-flex mt-auto pt-4 w-100">
					<b-card class="border-radius-1em border shadow-none w-100">
						 <h4>Sold By</h4>
						 <hr>
						 <div class="d-flex">
						 		<div class="" v-if="product.company.logo !== null">
						 			<router-link :to="'/seller/'+product.company.nickname+'/profile'">
						 				<b-img-lazy :src="'https://'+product.company.nickname + storageurl + product.company.logo.replaceAll('//', '/').replaceAll('https:/'+product.company.nickname+'.s3.eu-west-2.amazonaws.com', '')+'?s='+product.company.nickname+''" class="avatar-md rounded-circle border mr-4" />
						 			</router-link>
						 		</div>
						 		<div class="d-flex flex-column">
						 			<h5 class="mb-1 mt-auto">{{product.company.name}}</h5>
						 			<p>{{product.company.description.slice(0, 175)}}...</p>
						 			<router-link class="btn btn-light my-auto btn-rounded" :to="'/seller/'+product.company.nickname+'/profile'">
						 				See Products <i class="bx bx-store"></i>
						 			</router-link>
						 		</div>
						 		
						 </div>
					</b-card>
				</div>
			</b-col>
		</b-row>
		<b-row class="px-4 px-xl-0">
			<b-col md="12" class="d-flex mt-4" v-if="product.long_description !== null || product.long_description !== ''">
				<h2 class="product-info-header">More Information</h2>
				<hr class="mb-4 flex-grow-1">
			</b-col>
			<b-col md="6" class="offset-md-6" v-if="product.long_description !== null || product.long_description !== ''">
				<p class="mt-3 px-3" v-html="product.long_description"></p>
			</b-col>
			<b-col md="12" class="d-flex mt-4" v-if="product.attributes.length !== 0">
				<h2 class="product-info-header">Features</h2>
				<hr class="mb-4 flex-grow-1">
			</b-col>
			<b-col md="6" class="offset-md-6" v-if="product.attributes.length !== 0">
				
				<b-row>
				     <div class="col-md-12" v-if="product.attributes.length == 0">
                    <b-card class="shadow-none text-center border mb-2 py-4">
                      <i class="bx bxs-cube font-size-24 text-muted"></i>
                      <h4>No Active Features</h4>
                  </b-card>
                  </div>
                 <div class="col-md-12 mb-2" v-if="product.attributes.length !== 0">
                <div class="row">
               <div class="col-md-12">
                <div class="form-control-group">
                <b-list-group class="list-group" flush>
                	<div v-for="attribute_group in product.grouped_attributes">
                	   <li v-for="(active_attributes, index) in attribute_group" class="list-group-item p-0 d-flex py-3">
		                <span class="my-auto pl-4 w-25 d-flex">
		                  <img v-if="active_attributes.attribute.image" :src="'https://'+product.company.nickname + storageurl +'/'+ active_attributes.attribute.image + '?s='+product.company.nickname" class="my-auto avatar-sm rounded-circle mr-2">
		                  <!--<img v-else src="/images/product-placeholder.png" class="avatar-xs rounded-circle mr-2">-->
		               <div v-if="index == 0" class="my-auto">{{attribute_group[0].attribute.name}}</div>
		              </span>
		              <span class="w-25 d-flex">
		                <img v-if="active_attributes.value.image" :src="'https://'+ product.company.nickname + storageurl  +'/'+ active_attributes.value.image + '?s='+product.company.nickname" class="my-auto avatar-sm rounded-circle mr-3 border">
		                <div class="my-auto">{{active_attributes.value.name}}</div>
		              </span>
		              <span class="my-auto pr-4 w-50 d-flex">
		              	<span class="ml-auto">{{active_attributes.measurement_value}}{{active_attributes.units.suffix}}
		              	</span>
		              </span>
		              
					          </li>
			        </div>
			        </b-list-group>
			      </div>
			    </div>
			  </div>
			</div> 
			</b-row>
			</b-col>
			<b-col md="12" class="d-flex mt-4">
				<h2 class="product-info-header">Reviews</h2>
				<hr class="mb-4 flex-grow-1">
			</b-col>
			<b-col md="12">
				<b-row v-if="product.reviews.length > 0"  >
					<b-col>
						<ReviewCarousel :items="product.reviews" :swiperOptions="reviewOptions" ></ReviewCarousel>
					</b-col>
					<b-col md="12" class="d-flex">
						<a class="ml-auto btn btn-light" href="javascript:;" v-b-modal.modal-1 @click="form.action = 'review'">Write Review</a>
					</b-col>
				</b-row>
				<b-row v-else >
					<b-col md="12" class="text-center py-4">
						<i class="bx bx-star text-warning d-inline-block font-size-14"></i>
						<i class="bx bx-star text-warning d-inline-block font-size-20"></i>
						<i class="bx bx-star text-warning d-inline-block font-size-28"></i>
						<i class="bx bx-star text-warning d-inline-block font-size-20"></i>
						<i class="bx bx-star text-warning d-inline-block font-size-14"></i>
						<h4 class="text-muted">
							No Reviews
						</h4>
						<!--<a class="text-primary" href="javascript:;">
							Be the first to review this product
						</a>-->
						<a class="btn btn-light btn-rounded mb-2"  v-b-modal.modal-1 @click="form.action = 'review'">Be the first to review this product <i class="bx bx-star text-warning"></i></a>
					</b-col>
				</b-row>
			</b-col>
		</b-row>
		<!--<b-row>
			<b-col md="12" class="d-flex mt-4">
				<h2 class="product-info-header">Related Products</h2>
				<hr class="mb-4 flex-grow-1">
			</b-col>
			<b-col md="8" class="offset-md-4 overflow-hidden">
				<RelatedProducts :swiperOptions="swiperOptions" :items="product.related_products">
				</RelatedProducts>

			</b-col>
		</b-row>-->
		<b-row class="mt-4 py-4 px-4 px-xl-0" v-if="product.related_products.length !== 0">
			<b-col md="12" class="mt-4 overflow-hidden">
				<h2 class="product-info-header">Related Products</h2>
				<hr class="mb-4 flex-grow-1">
				<div class="pt-5">
				<RelatedProducts :swiperOptions="swiperOptions" :items="product.related_products" :startSlide="0">
				</RelatedProducts>
				</div>
			</b-col>
		</b-row>
		<b-row class="px-4 px-xl-0"  v-if="recentlyViewed && recentlyViewed.length > 0" >
			<b-col md="12" class="mt-4 overflow-hidden">
				<h2 class="product-info-header">You Recently Viewed</h2>
				<hr class="mb-4 flex-grow-1">
				<div class="pt-5">
				<RecentlyViewed v-if="recentlyViewed && recentlyViewed.length > 0"  :swiperOptions="swiperOptions" :items="recentlyViewedFiltered" :startSlide="0">
				</RecentlyViewed>
				</div>
			</b-col>
		</b-row>
		<b-modal id="modal-1" centered content-class="border-radius-1em" header-class="border-none" hide-footer>
			<b-card-body class="card-body pt-0">
            <div class="row">
            	<div class="col-sm-12 pb-4 text-center mb-4 d-flex">
            		<h3 class="section-info-header position-relative mx-auto">You are about to {{form.action}}</h3>
            	</div>
              <div class="col-sm-12 pb-4 text-center border border-radius-1em">
                <div class="avatar-md profile-user-wid mb-2 mx-auto" v-if="product.cover_image !== null" >
                  <img
                  v-if="'thumb' in product.cover_image" 
                  	 :src="'https://'+product.company.nickname + storageurl + product.cover_image.thumb+'?s='+product.company.nickname"
                    alt
                    class="img-thumbnail rounded-circle"
                  />
                  <img
                  v-else-if="'gallery' in product.cover_image" 
                  	 :src="'https://'+product.company.nickname + storageurl + product.cover_image.gallery+'?s='+product.company.nickname"
                    alt
                    class="img-thumbnail rounded-circle"
                  />
                  <img
                  v-else-if="'src' in product.cover_image" 
                  	 :src="'https://'+product.company.nickname + storageurl + product.cover_image.src+'?s='+product.company.nickname"
                    alt
                    class="img-thumbnail rounded-circle"
                  />
                   <span v-else class="avatar-title rounded-circle font-size-16 bg-light text-primary">{{product.name.slice(0,1)}}</span>
                </div>
                <div v-else class="avatar-md profile-user-wid mb-2 mx-auto">
                	<span class="avatar-title rounded-circle font-size-16 bg-light text-primary">{{product.name.slice(0,1)}}</span>
                </div>
                <h5 class="font-size-15 text-truncate">{{product.name}}</h5>
                <p class="paragraph-truncate-line2 font-size-12 mb-0 px-3" v-html="product.short_description"></p>
              </div>
           

            </div>
          </b-card-body>
    <b-form v-if="form.action == 'message'">
    	<b-form-group>
    		<b-form-input class="underline-input my-2" placeholder="First Name" type="text"></b-form-input>
    	</b-form-group>
    	<b-form-group>
    		<b-form-input class="underline-input my-2" placeholder="Last Name" type="text"></b-form-input>
    	</b-form-group>
    	<b-form-group>
    		<b-form-input class="underline-input my-2" placeholder="Email" type="text"></b-form-input>
    	</b-form-group>
    	<b-form-group>
    		<b-form-input class="underline-input my-2" placeholder="Telephone" type="text"></b-form-input>
    	</b-form-group>
    	<b-form-group>
    		<b-form-textarea
    		class="underline-input my-2"
		      id="textarea"
		      placeholder="Enter something..."
		      rows="4"
		    ></b-form-textarea>
    	</b-form-group>
    	<a class="btn btn-outline-light btn-rounded btn-block mt-3" href="javascript:;">Send Message</a>
    </b-form>

    <b-form v-if="((form.action == 'review') && (user)) && (hasReviewed(user.id) == -1)" class="px-2">
    	<b-form-group class="text-center">
    	<label class="mt-3 text-center section-info-header position-relative h4">Your Details</label>
    </b-form-group>
    <ReviewForm :source="'public'" :api_token="user.api_token" :product_id="product.id" :company_id="product.company_id" :user="user" :review_type="'product'"></ReviewForm>
    </b-form>
    <b-form v-if="(form.action == 'favourites')  && (user !== '')" class="px-2">
    	<b-overlay :show="loadingActionModal">
    		<b-card class="border-radius-1em shadow-none border" body-class="d-flex flex-column justify-content-center align-items-center py-3" v-if="favourites_status == true">
    			<i class="bx bx-check-circle font-size-48 text-success rounded-circle my-3"></i>
    			<h5>Product Added to Wishlist</h5>

    		</b-card>
    		<b-card class="border-radius-1em shadow-none border" body-class="d-flex flex-column justify-content-center align-items-center py-3" v-else-if="favourites_status == false">
    			<i class="bx bx-x-circle font-size-48 text-danger rounded-circle my-3"></i>
    			<h5>Product Removed from Wishlist</h5>

    		</b-card>
    	</b-overlay>
    	
    </b-form> 
    <b-form v-if="((form.action == 'favourites') || (form.action == 'review')) && (!user)" class="px-2">
    	<!--<a class="btn btn-outline-light btn-rounded btn-block mb-2" target="_blank">Sign In</a>-->
    	<Login submit-url="http://gemesys.co.uk/my-account/login" auth-error="">
             <input type="hidden" name="_token" :value="csrf">
        </Login>
        
    </b-form>
    <b-form v-if="((form.action == 'review') && (user)) && (hasReviewed(user.id) > -1)" class="px-2">
    	<h4 class="text-center">You have already reviewed this product</h4>
    	<p class="text-center">See your review below:</p>

    	<ReviewCarousel :items="[product.reviews[hasReviewed(user.id)]]" :swiperOptions="reviewOptions1"></ReviewCarousel>
    </b-form>
  </b-modal>
 <!-- <transition name="slide-fadepanel">
  <div class="edit-sidepanel" >
  		<iframe :src="product.tryon.link" allow="camera *; microphone *; fullscreen;" sandbox="allow-downloads allow-scripts allow-same-origin" style="width: 480px; height: 480px; max-width: 480px; max-height: 480px; border: none; overflow: hidden;" allowfullscreen></iframe>
  </div>
</transition>-->
	</b-container>
</template>


<style scoped >
#rating-inline{
	display: inline !important;
    padding: 0;
    width: auto !important;
}
#rating-inline .b-rating-star{
	padding: 0 5px 0 0 !important;
}
.spaced-title{
	letter-spacing: 0.9px;
}
</style>